import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu', 'menuClose', 'nav']

  toggle() {
    this.navTarget.classList.toggle('show_nav')
    this.menuTarget.classList.toggle('hide')
    this.menuCloseTarget.classList.toggle('hide')
  }

  teardown() {
    this.close()
  }

  close() {
    this.navTarget.classList.remove('show_nav')
    this.menuTarget.classList.remove('hide')
    this.menuCloseTarget.classList.add('hide')
  }
}
